"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
const react_1 = __importDefault(require("react"));
const Preloader_module_scss_1 = __importDefault(require("./Preloader.module.scss"));
function Preloader({ label, hasOverlay, progress }) {
    return (react_1.default.createElement("div", { className: Preloader_module_scss_1.default.container, "data-overlay": hasOverlay },
        react_1.default.createElement("div", { className: Preloader_module_scss_1.default.preloader },
            typeof progress === 'number' ? react_1.default.createElement("div", { className: Preloader_module_scss_1.default.progress, style: { width: `${progress}%` } }) : null,
            react_1.default.createElement("span", { className: Preloader_module_scss_1.default.label }, label))));
}
exports.default = Preloader;
